import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {NotificationType} from '~core/enum';
import {TablesTranslations} from '~shared/components/tables/tables-translations.service';
import {Customer, Order} from '~core/models';
import {DefaultNotificationService, MerchandisingService} from '~core/services';


/**
 * Fetch merchandising orders.
 */
@UntilDestroy()
@Component({
  selector: 'app-merchandising-list',
  templateUrl: 'merchandising-list.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class MerchandisingListComponent implements OnInit, OnDestroy {
  public hasAllOrders: boolean = false;
  public orders: Array<Order>;
  public limitItemsNum: number = 5;

  @Input() public customer: Customer;
  @Input() public isPanelOpened: boolean = true;
  @Output() public isPanelOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public customerService: CustomerOverViewService,
    public tablesTranslations: TablesTranslations,
    private notificationService: DefaultNotificationService,
    private ordersService: MerchandisingService
  ) {
  }

  /**
   * Fetches merchandising orders.
   */
  public ngOnInit(): any {
    this.getOrders();
  }

  public ngOnDestroy(): void {
  }

  /**
   * Get base merchandising orders for this customer.
   */
  public getOrders(): void {
    this.ordersService.getAll(this.customer.id).pipe(untilDestroyed(this))
      .subscribe({
        next: (res: Array<Order>) => {
          this.orders = res;
        },
        error: (error: Error) => {
          this.notificationService.showNotification({
            type: NotificationType.ALERT,
            message: 'Error fetching orders of this customer.'
          });
        }
      });
  }
}
